import {ISoundPlayer, ResourcesLoaded} from '@gongxigames/framework/core/types';
import {Store} from '@gongxigames/framework/core/fragments/store/Store';
import {ResourceLoader} from '@gongxigames/framework/core/services/resourceLoader/ResourceLoader';
import {UpdateManager} from '@gongxigames/framework/core/services/UpdateManager';
import {LanguageService} from '@gongxigames/framework/core/services/LanguageService';
import {CurrencyFormatter} from '@gongxigames/framework/core/services/CurrencyFormatter';
import {SpineUtils} from '@gongxigames/framework/core/services/SpineUtils';
import {Renderer} from 'pixi.js';
import {SoundManager} from '@gongxigames/framework/slot';

export const coreStore = Store.createStore({
    resources_loadedPackages: Store.signal({audio: [], graphics: []} as ResourcesLoaded),
    resourceLoader: Store.signal(null as null | ResourceLoader),
    updateManager: Store.signal(null as null | UpdateManager),
    languageService: Store.signal(null as null | LanguageService),
    currencyFormatter: Store.signal(null as null | CurrencyFormatter),
    spineUtils: Store.signal(null as null | SpineUtils),
    renderer: Store.signal(null as null | Renderer),
    soundPlayer: Store.signal(null as null | ISoundPlayer),
    soundManager: Store.signal(null as null | SoundManager),
});